module.exports = __webpack_public_path__ + "static/img/buy_en.422c2018.png";